import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Links from './Links.vue';
import Newsletter from './Newsletter.vue';
export default {
  name: 'LinksNewsletter',
  components: {
    Links: Links,
    Newsletter: Newsletter
  },
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};